export var TypeaheadMatch = (function () {
    function TypeaheadMatch(item, value, header) {
        if (value === void 0) { value = item; }
        if (header === void 0) { header = false; }
        this.item = item;
        this.value = value;
        this.header = header;
    }
    TypeaheadMatch.prototype.isHeader = function () {
        return this.header;
    };
    TypeaheadMatch.prototype.toString = function () {
        return this.value;
    };
    return TypeaheadMatch;
}());
//# sourceMappingURL=typeahead-match.class.js.map


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/ng2-bootstrap/typeahead/typeahead-match.class.js
// module id = ../../../../ng2-bootstrap/typeahead/typeahead-match.class.js
// module chunks = 4